export function historySlider() {
    let slideCount = 2.49;
    $(".history-slider").slick({
        infinite: false,
        slidesToShow: slideCount,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: ".history-date",
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1.7,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1.2,
                }
            }
        ]
    });
    $(".history-date").slick({
        infinite: false,
        slidesToShow: slideCount,
        slidesToScroll: 1,
        asNavFor: ".history-slider",
        arrows: false,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 1.7,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1.2,
                }
            }
        ]
    });
    let startWidth;
    let initWidth = 0;
    let negativeLeft;
    let blockCenter = 0;
    function sliderLineCalc(){
        blockCenter = initWidth + $(".history-date .slick-current").position().left;
        document.documentElement.style.setProperty("--dateSlWidth", `${blockCenter}px`);
    }
    $(window).on("load resize",  function () {
        negativeLeft = $(".history-date .slick-current").offset().left * -1;
        startWidth = $(".history-date .slick-current").offset().left + $(".history-date .slick-current").outerWidth() / 2;
        initWidth = $(".history-date .slick-current").outerWidth() / 2;
        document.documentElement.style.setProperty("--negativeLeft", `${negativeLeft}px`);
        document.documentElement.style.setProperty("--dateStartWidth", `${startWidth}px`);
        document.documentElement.style.setProperty("--initWidth", `${initWidth}px`);
    });
    $(".history-slider").on("beforeChange", function (){
        if( $(window).innerWidth() >= 1200 ){
            $(".history-slider h3 div").stop().slideUp();
            $(".history-slider .history-slider-desc").stop().slideUp();
        }
        sliderLineCalc();
    });
    $(".history-slider").on("afterChange", function (){
        if( $(window).innerWidth() >= 1200 ){
            $(".history-slider .slick-current h3 div").stop().slideDown();
            $(".history-slider .slick-current .history-slider-desc").stop().slideDown();
        }
    });
    $(".history-date .slick-current").click();
}


// WEBPACK FOOTER //
// ./assets/js/modules/history-slider.js